import React from 'react';

const MenuConfigPage = React.lazy(() => import('pages/MenuConfig/pages/MenuConfigAdd'));

const MenuConfigRoute = [
  {
    path: '/menu-config',
    exact: true,
    name: 'Cấu hình tiêu chí thiết lập menu',
    component: MenuConfigPage,
    // function: 'CRM_STAFF',
  },
];

export default MenuConfigRoute;
